<template>
  <div class="b1">
    <div class="b2">
      <iframe
        ref="ytFrame"
        src="https://www.youtube.com/embed/x5l1N5Jyy7U?rel=0&controls=1&loop=1&playlist=x5l1N5Jyy7U&enablejsapi=1"
        title="YouTube video player"
        style="width: 100%; height: 100%; aspect-ratio: 16 / 9; object-fit: contain"
        frameborder="0"
        allow="accelerometer; modestbranding; encrypted-media; web-share; gyroscope; picture-in-picture"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const iframe = this.$refs.ytFrame;
    const send = (func) => {
      try {
        iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func, args: '' }),
          '*'
        );
      } catch (e) { /* player may not be ready yet */ }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          send('pauseVideo');
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(iframe);
    this._ytObserver = observer;
  },
  beforeUnmount() {
    if (this._ytObserver) this._ytObserver.disconnect();
  },
};
</script>

<style scoped>
  .b1 {
    width: 100%;    
    background-color:#696759;
    padding-top: 4%;
    padding-bottom: 4%;
    display:flex;
    justify-content: center;
  }
  .b2 {
    width: 142vh !important;    
    height: 80vh !important;    
    object-fit:contain;            
  }
@media only screen and (max-width: 1152px) {
  .b2 {
    width: 90% !important;
    height: 50.625% !important;
  }
}
</style>
